import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  addNewInvoiceStatusSuccess,
  deleteInvoiceStatusSuccess,
  getInvoiceStatusList,
  updateInvoiceStatusSuccess,
} from "../../../../store/invoiceCrmIT/action";
import { toast } from "react-toastify";

import {
  proformaInvoiceStatusCreate,
  proformaInvoiceStatusDelete,
  proformaInvoiceStatusList,
  proformaInvoiceStatusUpdate,
  proformaInvoiceStatusUpdateSuccess,
} from "../../../../store/ProformaInvoice/action";
export default function ProformaInvoicingSettings() {
  const dispatch = useDispatch();

  const { invoiceStatusList } = useSelector((state) => ({
    invoiceStatusList:
      state.ProformaInvoice?.invoiceStatusListData?.proformainvoicestatus_list,
  }));

  const [paymentTerm, setPaymentTerm] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    LogicValue: "", //Duration
    LogicType: "", // Drop Down a type
  });

  const logicType = [
    {
      label: "Days",
      value: "1",
    },
    {
      label: "Months",
      value: "2",
    },
    {
      label: "Day of Next month",
      value: "3",
    },
    {
      label: "Last Day of the month",
      value: "4",
    },
    {
      label: "Last Working Day of the month",
      value: "5",
    },
  ];
  const [noColourChoiceRequired, setNoColourChoiceRequired] = useState(false);

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      // Task Status create
      dispatch(proformaInvoiceStatusCreate([createStatus]));
    }
    // if (activeTab === "2") {
    //   // Task Type create
    //   dispatch(addNewInvoicePaymentMethod([createStatus]));
    // }
    // if (activeTab === "3") {
    //   dispatch(createPaymentTerms([createStatus]));
    // }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = invoiceStatusList?.sort((a, b) => b.Id - a.Id);
      setNoColourChoiceRequired(false);
      setPaymentTerm(false);
    }

    setStatusList(data);
  }, [invoiceStatusList, activeTab]);

  useEffect(() => {
    dispatch(proformaInvoiceStatusList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //  Task Status delete
      dispatch(proformaInvoiceStatusDelete([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      LogicValue: updateItemStatus?.LogicValue,
      LogicType: updateItemStatus?.LogicType,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        // Task Status update
        dispatch(proformaInvoiceStatusUpdate([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // success Add Update Delete
  const {
    addInvoiceStatusSuccessApi,
    deleteInvoiceStatusSuccessAPI,
    updateInvoiceStatusSuccessAPI,
  } = useSelector((state) => ({
    addInvoiceStatusSuccessApi: state.ProformaInvoice.invoiceStatusCreateData,
    deleteInvoiceStatusSuccessAPI:
      state.ProformaInvoice.invoiceStatusDeleteData,
    updateInvoiceStatusSuccessAPI:
      state.ProformaInvoice.invoiceStatusUpdateData,
  }));

  // Add  Success Invoice Status
  useEffect(() => {
    if (isEmpty(addInvoiceStatusSuccessApi)) return;
    if (addInvoiceStatusSuccessApi?.status === 200) {
      toast.success(addInvoiceStatusSuccessApi?.message);
      dispatch(proformaInvoiceStatusList());
    } else {
      toast.error(addInvoiceStatusSuccessApi?.message);
    }
    dispatch(addNewInvoiceStatusSuccess([]));
  }, [addInvoiceStatusSuccessApi]);
  // Delete Success Invoice Status
  useEffect(() => {
    if (isEmpty(deleteInvoiceStatusSuccessAPI)) return;
    if (deleteInvoiceStatusSuccessAPI?.status === 200) {
      toast.success(deleteInvoiceStatusSuccessAPI?.message);
      dispatch(proformaInvoiceStatusList());
      setDeleteModal(false);
    } else {
      toast.error(deleteInvoiceStatusSuccessAPI?.message);
    }
    dispatch(deleteInvoiceStatusSuccess([]));
  }, [deleteInvoiceStatusSuccessAPI]);
  // Update Success Invoice Status
  useEffect(() => {
    if (isEmpty(updateInvoiceStatusSuccessAPI)) return;
    if (updateInvoiceStatusSuccessAPI?.status === 200) {
      toast.success(updateInvoiceStatusSuccessAPI?.message);
      dispatch(proformaInvoiceStatusList());
    } else {
      toast.error(updateInvoiceStatusSuccessAPI?.message);
    }
    dispatch(proformaInvoiceStatusUpdateSuccess([]));
  }, [updateInvoiceStatusSuccessAPI]);
  // Add  Success Invoice Payment Method

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Proforma Invoicing Settings"
        description="Statuses for proforma invoices."
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          noColourChoiceRequired={noColourChoiceRequired}
          logicType={logicType}
          paymentTerm={paymentTerm}
        />
      </SettingsPanel>
    </>
  );
}
